export const add = (x, y) => Number(x) + Number(y)
